import { COLORS, createFontStyle, MOBILE_FONT_STYLES } from '@cocolocala/ui-components';
import { styled } from 'linaria/react';
import React, { CSSProperties, FC, useMemo, useState } from 'react';
import InputErrorMessage from '~/shared/components/shared/InputErrorMessage';
type Props = {
  label?: string;
  errorMessage?: string;
  type?: string;
  minLength?: string | number;
  maxLength?: string | number;
  multiple?: boolean;
  require?: boolean;
  placeholder?: string;
  defaultValue?: string;
  value?: string;
  name?: string;
  textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase';
  autoComplete?: string;
  inputRef?: React.RefObject<HTMLInputElement> | ((instance: HTMLInputElement | null) => void) | null | undefined;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  data?: any;
  style?: CSSProperties;
};
const InputField: FC<Props> = props => {
  const hasError = typeof props.errorMessage !== 'undefined';
  const [value, setValue] = useState(props.defaultValue ?? props.value);
  // 入力がされていないか
  const isEmpty = useMemo(() => {
    return !value || value.length === 0;
  }, [value]);
  return <Container style={props.style}>
      {props.label && <Label>{props.label}</Label>}
      <Input type={props.type} name={props.name} maxLength={props.maxLength} minLength={props.minLength} multiple={props.multiple} placeholder={props.placeholder} defaultValue={props.defaultValue} value={props.value} ref={props.inputRef} onChange={e => {
      // 値を更新
      setValue(e.target.value);
      props.onChange?.(e);
    }} onFocus={props.onFocus} onBlur={props.onBlur} autoComplete={props.autoComplete} data-text-transform={props.textTransform} data-has-error={hasError ? 'true' : 'false'} data-is-empty={isEmpty ? 'true' : 'false'} data-is-require={props.require ? 'true' : 'false'} {...props.data}></Input>
      {hasError && <InputErrorMessage style={{
      marginTop: '10px'
    }}>
          {props.errorMessage}
        </InputErrorMessage>}
    </Container>;
};
export default InputField;
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c6erekk"
});
const Label = /*#__PURE__*/styled("label")({
  name: "Label",
  class: "l1li9chb"
});
const Input = /*#__PURE__*/styled("input")({
  name: "Input",
  class: "i1jvr4dp"
});

require("./index.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");